// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"ClienteDetalle_spinnerContainer__iHUHn"};